import React from 'react';
import { X, Copy, Send, MessageCircle, Mail, Share2 } from 'lucide-react';
import toast from 'react-hot-toast';

async function copyToClipboard(text) {
    const t = String(text || '');
    if (!t) return false;

    try {
        if (navigator?.clipboard?.writeText) {
            await navigator.clipboard.writeText(t);
            return true;
        }
    } catch (_) {
        // ignore
    }

    try {
        const ta = document.createElement('textarea');
        ta.value = t;
        ta.setAttribute('readonly', '');
        ta.style.position = 'fixed';
        ta.style.top = '-1000px';
        ta.style.left = '-1000px';
        document.body.appendChild(ta);
        ta.focus();
        ta.select();
        const ok = document.execCommand('copy');
        document.body.removeChild(ta);
        return !!ok;
    } catch (_) {
        return false;
    }
}

function buildLinks({ url, title, text }) {
    const u = encodeURIComponent(String(url || ''));
    const t = encodeURIComponent(String(title || ''));
    const d = encodeURIComponent(String(text || ''));
    const wa = encodeURIComponent([text, url].filter(Boolean).join(' '));
    const mailBody = encodeURIComponent([text, url].filter(Boolean).join('\n\n'));

    return {
        telegram: `https://t.me/share/url?url=${u}${text ? `&text=${d}` : ''}`,
        vk: `https://vk.com/share.php?url=${u}`,
        ok: `https://connect.ok.ru/offer?url=${u}${title ? `&title=${t}` : ''}${text ? `&description=${d}` : ''}`,
        email: `mailto:?subject=${t || encodeURIComponent('Ссылка')}&body=${mailBody}`
    };
}

export default function ShareModal({ isOpen, onClose, url, title, text }) {
    if (!isOpen) return null;

    const links = buildLinks({ url, title, text });

    const items = [
        { key: 'telegram', label: 'Telegram', href: links.telegram, Icon: Send },
        { key: 'vk', label: 'VK', href: links.vk, Icon: Share2 },
        { key: 'ok', label: 'OK', href: links.ok, Icon: Share2 },
        { key: 'email', label: 'Email', href: links.email, Icon: Mail }
    ];

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
            <div className="bg-white rounded-xl shadow-2xl max-w-md w-full max-h-[90vh] overflow-y-auto">
                <div className="flex items-center justify-between p-5 border-b border-gray-200">
                    <div className="min-w-0">
                        <div className="text-sm text-gray-500">Поделиться</div>
                        <div className="text-lg font-semibold text-gray-900 truncate">{title || 'Ссылка'}</div>
                    </div>
                    <button
                        onClick={onClose}
                        className="p-2 hover:bg-gray-100 rounded-full transition-colors"
                        aria-label="Закрыть"
                        type="button"
                    >
                        <X className="w-5 h-5 text-gray-500" />
                    </button>
                </div>

                <div className="p-5">
                    <div className="grid grid-cols-1 gap-2">
                        {items.map(({ key, label, href, Icon }) => (
                            <a
                                key={key}
                                href={href}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="flex items-center gap-3 px-4 py-3 rounded-lg border border-gray-200 hover:bg-gray-50 transition"
                                onClick={() => {
                                    // close immediately to feel responsive
                                    try { onClose && onClose(); } catch (_) { }
                                }}
                            >
                                <Icon className="w-5 h-5 text-gray-700" />
                                <span className="text-gray-900 font-medium">{label}</span>
                            </a>
                        ))}
                    </div>

                    <div className="mt-4">
                        <div className="text-xs text-gray-500 mb-2">Или</div>
                        <button
                            type="button"
                            className="w-full flex items-center justify-center gap-2 px-4 py-3 rounded-lg border border-gray-200 bg-white hover:bg-gray-50 transition"
                            onClick={async () => {
                                const ok = await copyToClipboard(url);
                                if (ok) {
                                    toast.success('Ссылка скопирована');
                                    onClose();
                                } else {
                                    toast.error('Не удалось скопировать ссылку');
                                }
                            }}
                        >
                            <Copy className="w-4 h-4 text-gray-700" />
                            <span className="text-gray-900 font-medium">Скопировать ссылку</span>
                        </button>

                        {url ? (
                            <div className="mt-2 text-xs text-gray-500 break-all">{url}</div>
                        ) : null}
                    </div>
                </div>
            </div>
        </div>
    );
}

